export var Settings = {
    /**
     * @description Enable debug mode, will throw error descriptions
     */
    ENABLE_DEBUG: true,
    /**
     * @description Printing a instruction code that was compiled to JS
     */
    PRINT_BYTE_INSTRUCTION: false,
    /**
     * @description Use a XRegExp when RegExp require a lookbehinde pattern on Safari
     */
    EMULATE_LOOKBEHIND: true,
    /**
     * @description Guard to avoid infinity loops, throw exception
     */
    ENABLE_LOOP_QUARD: false,
    /**
     * @description  How many branching jumps required for enable guarding except Exceptions
     */
    LOOP_GUARD_MIN_BRANCHES: 3,
    LOOP_GUARD_MAX_LOOPS: 100000,
    /**
     * @description Restirct coerce bechaviour
     */
    COERCE_MODE: "soft" /* SOFT */,
    /**
     * @description Validate names in compile process and fall to interpret when it invalid for compilation
     */
    CHECK_OBFUSCATED_NAME: false,
    /**
     * @description Disallow falling to interpret mode
     */
    NO_FALL_TO_INT: true,
    /**
     * @description Disable scope proporgardition for try-catch blocks
     */
    NO_PROPAGATE_SCOPES_FOR_TRY: true,
};
